<template>
  <div class="page">
    <slot />
  </div>
</template>

<style scoped>
  .page {
    background-color: rgb(255, 255, 255);
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    overflow-y: scroll;
    box-sizing: border-box;
  }
</style>
